






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EAutoPaySettingStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { AUTO_PAYMENT_SETTING_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusAutoPaymentSetting extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }
    switch (this.$props.status) {
      case EAutoPaySettingStatus.COMPLETE:
        return EStatusType.success
      case EAutoPaySettingStatus.ACTIVE:
        return EStatusType.pending
      case EAutoPaySettingStatus.DELETED:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return AUTO_PAYMENT_SETTING_STATUSES_LABEL_MAP[this.$props.status]
  }
}
